<template>
  <!-- 
    Компонент обертка.
    В компоненте создаются вложенные друг в друга div`ы, в количестве count и внутри последнего передается slot.
    Клик на каждый элемент вызывает метод handle_click благодаря всплытию.
    Сделано для корректного проигрывания/переключения видео на iOs,
    в котором необходимо из одного непосредственно клика юзера создать несколько событий клика.
    emit событий, вызов триггеров клика и т.д. iOs в данном случае блокирует, и работает только такая логика.
  -->
  <div @click="on_click">
    <vrecursive-block v-if="count > 0" :count="count - 1" :current_index="current_index" :handle_click="handle_click">
      <slot></slot>
    </vrecursive-block>
    <slot v-if="count === 0"></slot>
  </div>
</template>

<script>
export default {
  name: 'vrecursive-block',
  props: {
    count: Number,
    handle_click: Function,
    current_index: Number
  },

  methods: {
    on_click() {
      this.handle_click(this.count, this.current_index)
    }
  }
}
</script>